import React from "react";
import { Button, Modal } from "react-bootstrap";

import styles from "../../styles/SupportTickets.module.css";

const ConfirmModal = ({
  show,
  onHide,
  title,
  body,
  confirmLabel,
  confirmVariant = "danger",
  onConfirm,
  isConfirming,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered className={styles.SupportModal}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} className={styles.SupportBtn}>
          Cancel
        </Button>
        <Button
          variant={confirmVariant}
          onClick={onConfirm}
          disabled={isConfirming}
          className={styles.SupportBtn}
        >
          {isConfirming ? "Please wait..." : confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;

